// extracted by mini-css-extract-plugin
export default {"svg":"CircularProgress_svg__v3slH","rotate":"CircularProgress_rotate__06fRh","circle":"CircularProgress_circle__mqf8E","dash":"CircularProgress_dash__pF4Rv"};